import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import injectTranslate from 'i18n/hoc/injectTranslate'

import RenderField from 'components/RenderField/RenderFieldContainer'

const AnimatedPasswordField = ({
  label = 'label',
  toggleDisabled = false,
  translate = () => {},
  ...props
}) => {
  const [state, setState] = useState({
    hideLabel: true,
    passwordInputType: 'password',
    passwordIcon: 'eye',
  })
  const [field, setField] = useState(null)

  useEffect(() => {
    if (toggleDisabled) {
      setState({ ...state, passwordIcon: 'pwd-login' })
    }
    if (field) {
      setState({ ...state, hideLabel: false })
    }
  }, [])

  const togglePassword = () => {
    if (toggleDisabled) return
    setState({
      ...state,
      passwordInputType:
        state.passwordInputType === 'password' ? 'text' : 'password',
      passwordIcon: state.passwordIcon === 'eye' ? 'opened-eye' : 'eye',
    })
  }

  const handleChange = e =>
    setState({ ...state, hideLabel: e.currentTarget.value === '' })

  return (
    <Field
      {...props}
      ref={input => setField(input)}
      label={label}
      hideLabel={state.hideLabel}
      placeholder={label}
      onChange={e => handleChange(e)}
      component={RenderField}
      onIconClick={() => togglePassword()}
      type={state.passwordInputType}
      icon={state.passwordIcon}
      alt={toggleDisabled ? translate('password.eye.disable.tooltip') : ''}
    />
  )
}

AnimatedPasswordField.prototype = {
  name: PropTypes.string.isRequired,
  translate: PropTypes.func,
  label: PropTypes.string,
  toggleDisabled: PropTypes.bool,
}

export default injectTranslate(AnimatedPasswordField)
